<ng-container>
    <div class="spinner-container" *ngIf="(isSearchFormReady$ | async)===false else formready;">
        <mat-spinner></mat-spinner>
    </div>
    <ng-template #formready>
        <div class="appform-header">
            <button #buttons id="createApplicationButton" routerLink="/application_form" (click)="newOnClick()">
                    <span>New</span>
                </button>
        </div>
        <div class="appform-container">
            <h2 class="section-header">Search</h2>
            <app-search-header></app-search-header>
            <div class="container-section">
                <div class="spinner-container" *ngIf="(areSearchLoading$ | async)===false;">
                    <mat-spinner></mat-spinner>
                </div>
                <div *ngIf="isTableLoaded">
                    <app-search-detail [dataSource]="dataSource" [displayedColumns]="displayedColumns" [activeSortColumn]="matSortActive" [activeSortDirection]="matSortDirection" (viewButtonClick)="viewApplication($event)" (sortChange)="onSearchChanged($event)"></app-search-detail>
                </div>
                <div class="mat-elevation-z8" [class.hidden]="(areSearchLoading$ | async)===false">
                    <mat-paginator (page)="onPageSelect($event)" [pageIndex]="pageIndex" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" showFirstLastButtons aria-label="Select page of periodic elements">
                    </mat-paginator>
                </div>
            </div>
        </div>
    </ng-template>
</ng-container>